import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head-awareness'
import pdfMake from 'pdfmake/build/pdfmake'
import { dateFormat } from '@/Utils/fliter'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
const exportPdfDetails = async (baseUrl, uri = '/configuration/report-heading/detail', orgId, reportTitle, formData, vm) => {
    try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }

      const blankLine = {
        table: {
          headerRows: 0,
          widths: ['100%'],
          body: [
            [
              { text: '', style: 'thHr', alignment: 'center' }
            ]
          ]
        },
        layout: 'noBorders'
      }
        const reportHeadData = await ReportHeading.getReportHead(baseUrl, uri, orgId)
        const waterMarkText = i18n.locale === 'bn' ? 'সমাজকল্যাণ মন্ত্রণালয়' : 'Ministry of Social Welfare'
      const pdfContent = [
        {
          columns: reportHeadData.reportHeadColumn
        },
        { text: reportHeadData.orgName, style: 'orgName', alignment: 'center' },
        { text: reportHeadData.address, style: 'address', alignment: 'center' }
      ]
      pdfContent.push({ text: '', style: 'header2', alignment: 'center' })

      pdfContent.push(
        {
          table: {
            headerRows: 0,
            widths: ['32%', '21%', '30%', '2%', '15%'],
            body: [
              [
                { text: vm.$t('delivery_management.distribution_receipt'), style: 'thHead', alignment: 'left', rowSpan: 2, fillColor: '#dddddd' },
                { },
                { text: vm.$t('delivery_management.receipt_no'), style: 'th', alignment: 'right' },
                { text: ':', style: 'th', alignment: 'right' },
                { text: vm.$n(formData.receipt_no, { useGrouping: false }), style: 'th', alignment: 'right' }
              ],
              [
                {},
                {},
                { text: vm.$t('delivery_management.distributed_date'), style: 'th', alignment: 'right' },
                { text: ':', style: 'th', alignment: 'right' },
                { text: dateFormat(formData.distributed_date), style: 'th', alignment: 'right' }
              ]
            ]
          },
          layout: 'noBorders'
        }
      )
      pdfContent.push(
        {
          table: {
            headerRows: 0,
            widths: ['100%'],
            body: [
              [
                { text: '', style: 'thHr', alignment: 'center', border: [false, false, false, true], opacity: 0.1, bold: true }
              ]
            ]
          }
        }
      )
      pdfContent.push(
        blankLine
      )
      // header end
      // Application Details start
      pdfContent.push(
        {
          table: {
            headerRows: 0,
            widths: ['30%', '2%', '68%'],
            body: [
              [
                { text: vm.$t('delivery_management.total_assistive'), style: 'th', alignment: 'left' },
                { text: ':', style: 'th', alignment: 'center' },
                { text: vm.$n(formData.total_devices, { useGrouping: false }), style: 'th', alignment: 'left' }
              ],
              [
                { text: vm.$t('delivery_management.distributed_quantity_pcs'), style: 'th', alignment: 'left' },
                { text: ':', style: 'th', alignment: 'center' },
                { text: dateFormat(formData.total_distributed_quantity), style: 'th', alignment: 'left' }
              ],
              [
                { text: vm.$t('assitive_device_management.idsc_center'), style: 'th', alignment: 'left' },
                { text: ':', style: 'th', alignment: 'center' },
                { text: vm.i18n === 'bn' ? formData.center_name_bn : formData.center_name_en, style: 'th', alignment: 'left' }
              ],
              [
                { text: vm.$t('grant_registration.application_type'), style: 'th', alignment: 'left' },
                { text: ':', style: 'th', alignment: 'center' },
                { text: vm.i18n === 'bn' ? formData.application_type_bn : formData.application_type_en, style: 'th', bold: true, alignment: 'left' }
              ]
            ]
          },
          layout: 'noBorders'
        }
      )
      pdfContent.push(
        blankLine
      )
      // Application Details end
      // Device List start
      pdfContent.push(
        {
          style: 'tableExample',
          table: {
            body: [
              [{ text: vm.$t('assitive_device_management.distributed_device_list'), style: 'tableHeader', fillColor: '#dddddd' }, { text: ':', fillColor: '#dddddd' }]
            ]
          },
          layout: 'noBorders'
        }
      )
      pdfContent.push(
        blankLine
      )
      const topRowsData = [
        [
          { text: vm.$t('globalTrans.sl_no'), bold: true, style: 'th', fillColor: '#dddddd', alignment: 'center' },
          { text: vm.$t('assitive_device_management.device_name'), bold: true, style: 'th', fillColor: '#dddddd', alignment: 'left' },
          { text: vm.$t('assitive_device_management.requested_quantity'), bold: true, style: 'th', fillColor: '#dddddd', alignment: 'left' },
          { text: vm.$t('assitive_device_management.approved_quantity'), bold: true, style: 'th', fillColor: '#dddddd', alignment: 'left' },
          { text: vm.$t('assitive_device_management.distributed_quantity'), bold: true, style: 'th', fillColor: '#dddddd', alignment: 'left' },
          { text: vm.$t('assitive_device_management.rest_quantity'), bold: true, style: 'th', fillColor: '#dddddd', alignment: 'left' },
          { text: vm.$t('globalTrans.remarks'), bold: true, style: 'th', fillColor: '#dddddd', alignment: 'left' }
        ]
      ]
      formData.details.map((item, index) => {
        topRowsData.push([
          { text: vm.$n(index + 1), style: 'td' },
          { text: vm.deviceNameById(item.assistive_device_id), style: 'td' },
          { text: vm.$n(item.no_of_quantity), style: 'td' },
          { text: vm.$n(item.approved_quantity), style: 'td' },
          { text: vm.$n(item.distributed_quantity), bold: true, style: 'td' },
          { text: vm.$n(item.rest_quantity), bold: true, style: 'td' },
          { text: item.remarks, style: 'td' }
        ])
      })
      pdfContent.push({
        table: {
          headerRows: 1,
          widths: ['5%', '*', '*', '*', '*', '*', '*'],
          body: topRowsData
        }
      })
      pdfContent.push(
        blankLine
      )
      // Device List end
      // Applicant Details Start
      pdfContent.push(
        {
          style: 'tableExample',
          table: {
            body: [
              [{ text: vm.$t('assitive_device_management.patient_organization_representative_details'), style: 'tableHeader', fillColor: '#dddddd' }, { text: ':', fillColor: '#dddddd' }]
            ]
          },
          layout: 'noBorders'
        }
      )
      pdfContent.push(
        blankLine
      )
      if (formData.application.application_type === 1) {
        pdfContent.push(
          {
            table: {
              headerRows: 0,
              widths: ['30%', '2%', '68%'],
              body: [
                [
                  { text: vm.$t('globalTrans.name'), style: 'th', alignment: 'left' },
                  { text: ':', style: 'th', alignment: 'center' },
                  { text: vm.i18n === 'bn' ? formData.name_bn : formData.name_en, style: 'th', alignment: 'left' }
                ],
                [
                  { text: vm.$t('retailerManagement.father_name'), style: 'th', alignment: 'left' },
                  { text: ':', style: 'th', alignment: 'center' },
                  { text: vm.i18n === 'bn' ? formData.father_name_bn : formData.father_name_en, style: 'th', alignment: 'left' }
                ],
                [
                  { text: vm.$t('retailerManagement.mother_name'), style: 'th', alignment: 'left' },
                  { text: ':', style: 'th', alignment: 'center' },
                  { text: vm.i18n === 'bn' ? formData.mother_name_bn : formData.mother_name_en, style: 'th', alignment: 'left' }
                ],
                [
                  { text: vm.$t('info_manage.birth_date'), style: 'th', alignment: 'left' },
                  { text: ':', style: 'th', alignment: 'center' },
                  { text: dateFormat(formData.birth_date), style: 'th', bold: true, alignment: 'left' }
                ],
                [
                  { text: vm.$t('retailerManagement.email'), style: 'th', alignment: 'left' },
                  { text: ':', style: 'th', alignment: 'center' },
                  { text: formData.application.email, style: 'th', alignment: 'left' }
                ],
                [
                  { text: vm.$t('retailerManagement.nid'), style: 'th', alignment: 'left' },
                  { text: ':', style: 'th', alignment: 'center' },
                  { text: vm.$n(formData.nid, { useGrouping: false }), style: 'th', alignment: 'left' }
                ]
              ]
            },
            layout: 'noBorders'
          }
        )
      } else {
        pdfContent.push(
          {
            table: {
              headerRows: 0,
              widths: ['30%', '2%', '68%'],
              body: [
                [
                  { text: vm.$t('globalTrans.name'), style: 'th', alignment: 'left' },
                  { text: ':', style: 'th', alignment: 'center' },
                  { text: vm.i18n === 'bn' ? formData.name_bn : formData.name_en, style: 'th', alignment: 'left' }
                ],
                [
                  { text: vm.$t('globalTrans.designation'), style: 'th', alignment: 'left' },
                  { text: ':', style: 'th', alignment: 'center' },
                  { text: vm.i18n === 'bn' ? formData.application.designation_bn : formData.application.designation_en, style: 'th', alignment: 'left' }
                ],
                [
                  { text: vm.$t('globalTrans.organization'), style: 'th', alignment: 'left' },
                  { text: ':', style: 'th', alignment: 'center' },
                  { text: vm.i18n === 'bn' ? formData.application.organization_name_bn : formData.application.organization_name_en, style: 'th', alignment: 'left' }
                ],
                [
                  { text: vm.$t('sales_distribution_admin.contact_no'), style: 'th', alignment: 'left' },
                  { text: ':', style: 'th', alignment: 'center' },
                  { text: vm.$n(formData.application.contact_no, { useGrouping: false }), style: 'th', alignment: 'left' }
                ],
                [
                  { text: vm.$t('retailerManagement.email'), style: 'th', alignment: 'left' },
                  { text: ':', style: 'th', alignment: 'center' },
                  { text: formData.application.email, style: 'th', alignment: 'left' }
                ]
              ]
            },
            layout: 'noBorders'
          }
        )
      }
      pdfContent.push(
        blankLine
      )
      pdfContent.push(
        blankLine
      )
      pdfContent.push(
        blankLine
      )
      pdfContent.push(
        blankLine
      )
      pdfContent.push(
        blankLine
      )
      pdfContent.push(
        {
          table: {
            headerRows: 0,
            widths: ['100%'],
            body: [
              [
                { text: vm.$t('delivery_management.received_by') + '----------------------------', style: 'th', alignment: 'left' }
              ]
            ]
          },
          layout: 'noBorders'
        }
      )

      // Applicant Details end
        var docDefinition = {
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'Portrait',
        watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
        styles: {
          thHr: {
            bold: true,
            fontSize: (i18n === 'bn') ? 18 : 16,
            margin: [3, 10, 3, 3]
          },
          thHead: {
            bold: true,
            fontSize: (i18n === 'bn') ? 18 : 16,
            margin: [3, 10, 3, 3]
          },
          tableHeader: {
            fontSize: 12
          },
          th: {
            bold: true,
            fontSize: (i18n === 'bn') ? 12 : 10,
            margin: [3, 3, 3, 3]
          },
          td: {
            fontSize: (i18n === 'bn') ? 12 : 10,
            margin: [3, 3, 3, 3]
          },
          header: {
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 0]
          },
          org: {
              fontSize: 10,
              bold: true,
              margin: [-10, 0, 0, 0]
          },
          address: {
              fontSize: 9,
              margin: [10, 0, 0, 0]
          },
          hh: {
              fontSize: 13,
              bold: true,
              margin: [10, 10, 25, 20]
          },
          header2: {
            fontSize: 14,
            margin: [0, 10, 0, 20]
          },
          fertilizer: {
            fontSize: 10,
            margin: [10, 10, 0, 20]
          },
          headerPort1: {
            bold: true,
            fontSize: (i18n === 'bn') ? 13 : 12,
            margin: [0, 20, 0, 0]
          },
          headerPort: {
            fontSize: 10,
            margin: [0, 4, 0, 15]
          },
          krishi: {
            margin: [0, -5, 0, 15],
            alignment: 'center'
          },
          header3: {
            fontSize: 9,
            margin: [0, 0, 0, 4]
          },
          tableSubHead: {
            margin: [0, 5, 0, 15]
          },
          tableMargin: {
            margin: [0, 15, 0, 0]
          },
          orgName: {
            fontSize: 10,
            margin: [-10, 0, 0, 0]
          }
        }
      }
      // pdfMake.createPdf(docDefinition, null, null, null).download('employer-details')
      pdfMake.createPdf(docDefinition, null, null, null).print()
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
